import { Fragment } from 'react';
import { Link } from 'wouter';
import { AccordionSection } from '@medifind/containers';
import { toSlug } from '@medifind/router';
import { Skeleton } from '@medifind/shared-basic-components';
import styles from './ClinicalTrialShared.module.scss';

const ClinicalTrialAuthors = ({ authors, isLoading, codingType, projectId, codingSlug }) => {
  return (
    <AccordionSection
      classes={{
        container: styles['accordian-container'],
        header: styles['accordian-header'],
        title: styles['accordian-title'],
        body: styles['accordian-body'],
      }}
      expandable
      title="Authors"
      isLoading={isLoading}
    >
      {authors ? (
        authors.map(({ valid, displayName, personPersonifyId, validForCondition }, i) => {
          if (valid) {
            const authorSlug = toSlug(displayName);
            let doctorHref;
            if (process.env.NX_APP === 'MediFind') {
              doctorHref = `/doctors/${authorSlug}/${personPersonifyId}`;
              if (projectId && codingType && validForCondition) {
                doctorHref = `/${codingType}s/${codingSlug}/${projectId}/doctors/${authorSlug}/${personPersonifyId}`;
              }
            } else {
              doctorHref = `/people/${personPersonifyId}`;
            }
            return (
              <Fragment key={i}>
                {i > 0 ? ', ' : null}
                <Link to={doctorHref}>{displayName}</Link>
              </Fragment>
            );
          }
          return (
            <Fragment key={i}>
              {i > 0 ? ', ' : null}
              {displayName}
            </Fragment>
          );
        })
      ) : (
        <Skeleton count={3} />
      )}
    </AccordionSection>
  );
};

export { ClinicalTrialAuthors as default, ClinicalTrialAuthors };
